import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home';
import Content from '@/pages/content';
import ServiceOnline from '@/pages/serviceonline/Serviceonline';
import Contact from '@/pages/content/Contact';
import Law from '@/pages/content/Law';
import Test from '@/pages/content/Test';
import Search from '@/pages/search';
import Link from '@/pages/link';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'Home' },
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/content',
      name: 'Content',
      component: Content,
    },
    {
      path: '/online',
      name: 'ServiceOnline',
      component: ServiceOnline,
    },
    {
      path: '/link',
      name: 'Link',
      component: Link,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/law',
      name: 'Law',
      component: Law,
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js